export default __webpack_public_path__ + "static/media/ak.9c91f4bb.jpeg";